<template>
<m-setup-wrapper @startGame="startGame">

  <m-game-settings
    v-model="gameSettings"
    :enabled-settings="{ pairAmount: true }"
    class="mb4"></m-game-settings>
  <player-list :permissions="'all'" v-model="lobbyPlayers"></player-list>

</m-setup-wrapper>
</template>

<script>
import PlayerList from '@/components/PlayerList.vue';
import SetupBase from '@/components/setup/SetupBase.vue';

export default {
  extends: SetupBase,
  methods: {
    async startGame() {
      const finalGameSettings = Object.assign({}, this.gameSettings, {
        gameMode: 'classic'
      })
      const cards = this.$utils.generateLayout(finalGameSettings);
      await this.$store.dispatch('setupGame', {
        gameSettings: finalGameSettings,
        cards,
      });
    },
  }, 

  created() {
    this.$store.dispatch('setupLocalLobby');
  }
};
</script>

<style lang="scss" scoped>
</style>
